module.exports = __webpack_public_path__ + "static/media/c3_2.51646a27.png";